import { useState } from "react";

const morning = [
  { step: "01", product: "Bioderma Sensibio H2O", note: "Jemné stieranie, netreba opláchnuť" },
  { step: "02", product: "Round Lab Birch Juice Cleanser", note: "Umytie vlažnou vodou" },
  { step: "03", product: "Numbuzin NAD+ PDRN Toner", note: "Patting technikou" },
  { step: "04", product: "NAD+ Bio Lifting-Sil Essence", note: "" },
  { step: "05", product: "Nivea Cellular Luminous 630", note: "Oblast oka" },
  { step: "06", product: "Medipeel Golden Camellia Wrinkle Cream", note: "" },
  { step: "07", product: "⚠ SPF 50+", note: "Dokúpiť – nevynechávať!", alert: true },
  { step: "08", product: "Makeup", note: "" },
];

const evening = [
  { step: "01", product: "Bioderma Sensibio H2O", note: "Odlíčenie očí a prvý sweep" },
  { step: "02", product: "Anua Heartleaf Cleansing Oil", note: "Rozpustí makeup" },
  { step: "03", product: "Round Lab Birch Juice Cleanser", note: "Dočistenie" },
  { step: "04", product: "Numbuzin NAD+ PDRN Toner", note: "Patting technikou" },
  { step: "05", product: "NAD+ Bio Lifting-Sil Essence", note: "" },
  { step: "06", product: "Medipeel Golden Camellia Wrinkle Essence", note: "" },
  { step: "07", product: "Nivea Cellular Luminous 630", note: "Oblasť oka" },
  { step: "08", product: "Medipeel Golden Camellia Wrinkle Cream", note: "" },
  { step: "09", product: "Cicaplast B5+", note: "2–3× týždeň, posledný krok", optional: true },
];

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Jost:wght@300;400;500&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .wrap {
    min-height: 100vh;
    background: #faf7f4;
    padding: 48px 20px 64px;
    font-family: 'Jost', sans-serif;
  }

  .inner { max-width: 680px; margin: 0 auto; }

  .header {
    text-align: center;
    margin-bottom: 52px;
  }

  .eyebrow {
    font-family: 'Jost', sans-serif;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 4px;
    text-transform: uppercase;
    color: #b8977e;
    margin-bottom: 14px;
  }

  h1 {
    font-family: 'Cormorant Garamond', serif;
    font-size: 42px;
    font-weight: 300;
    color: #2a1f1a;
    line-height: 1.15;
    margin-bottom: 10px;
  }

  h1 em {
    font-style: italic;
    color: #9c7560;
  }

  .subtitle {
    font-size: 13px;
    font-weight: 300;
    color: #9e8b7e;
    letter-spacing: 0.5px;
  }

  .divider {
    width: 48px;
    height: 1px;
    background: linear-gradient(90deg, transparent, #c9a98a, transparent);
    margin: 20px auto 0;
  }

  .tabs {
    display: flex;
    gap: 0;
    background: #f0ebe6;
    border-radius: 40px;
    padding: 4px;
    margin-bottom: 36px;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }

  .tab {
    padding: 10px 32px;
    border-radius: 36px;
    border: none;
    cursor: pointer;
    font-family: 'Jost', sans-serif;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 2px;
    text-transform: uppercase;
    transition: all 0.3s ease;
    background: transparent;
    color: #9e8b7e;
  }

  .tab.active {
    background: #2a1f1a;
    color: #faf7f4;
    box-shadow: 0 2px 12px rgba(42,31,26,0.18);
  }

  .section-label {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
  }

  .section-label-line {
    flex: 1;
    height: 1px;
    background: #e2d8d0;
  }

  .section-label-text {
    font-family: 'Cormorant Garamond', serif;
    font-size: 22px;
    font-weight: 400;
    color: #2a1f1a;
    white-space: nowrap;
  }

  .section-label-icon {
    font-size: 18px;
  }

  .rows { display: flex; flex-direction: column; gap: 2px; }

  .row {
    display: grid;
    grid-template-columns: 36px 1fr auto;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #ede7e1;
    transition: box-shadow 0.2s, transform 0.2s;
    animation: fadeUp 0.35s ease both;
  }

  .row:hover {
    box-shadow: 0 4px 20px rgba(42,31,26,0.07);
    transform: translateY(-1px);
  }

  .row.alert-row {
    background: #fff8f3;
    border-color: #e8c4a2;
  }

  .row.optional-row {
    background: #f7faf7;
    border-color: #c8ddc8;
  }

  .step-num {
    font-family: 'Cormorant Garamond', serif;
    font-size: 15px;
    font-weight: 600;
    color: #c9a98a;
    line-height: 1;
  }

  .product-name {
    font-size: 14px;
    font-weight: 400;
    color: #2a1f1a;
    line-height: 1.3;
  }

  .product-note {
    font-size: 11.5px;
    font-weight: 300;
    color: #a8978b;
    margin-top: 3px;
    letter-spacing: 0.2px;
  }

  .badge {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 3px 10px;
    border-radius: 20px;
    white-space: nowrap;
  }

  .badge-alert {
    background: #fde8d4;
    color: #b86a2e;
  }

  .badge-optional {
    background: #ddeedd;
    color: #4a7a4a;
  }

  .note-box {
    margin-top: 28px;
    padding: 18px 22px;
    background: linear-gradient(135deg, #fdf6f0, #faf2ec);
    border-radius: 14px;
    border-left: 3px solid #c9a98a;
  }

  .note-box p {
    font-size: 12.5px;
    font-weight: 300;
    color: #7a6560;
    line-height: 1.7;
  }

  .note-box strong {
    font-weight: 500;
    color: #4a3530;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export default function SkincareRoutine() {
  const getDefaultTab = () => {
    const h = new Date().getHours();
    return h >= 3 && h < 17 ? "morning" : "evening";
  };
  const [tab, setTab] = useState(getDefaultTab);
  const steps = tab === "morning" ? morning : evening;

  return (
    <>
      <style>{style}</style>
      <div className="wrap">
        <div className="inner">
          <div className="header">
            <div className="eyebrow">Skincare · každý deň</div>
            <h1>Tvoja <em>rutina</em></h1>
            <p className="subtitle">46r · kombinovaná/suchšia · vrásky · pigmentácia</p>
            <div className="divider" />
          </div>

          <div className="tabs">
            <button
              className={`tab ${tab === "morning" ? "active" : ""}`}
              onClick={() => setTab("morning")}
            >
              ☀ Ráno
            </button>
            <button
              className={`tab ${tab === "evening" ? "active" : ""}`}
              onClick={() => setTab("evening")}
            >
              ☽ Večer
            </button>
          </div>

          <div className="section-label">
            <div className="section-label-line" />
            <span className="section-label-text">
              {tab === "morning" ? "☀\ufe0f Ranná rutina" : "🌙 Večerná rutina"}
            </span>
            <div className="section-label-line" />
          </div>

          <div className="rows">
            {steps.map((s, i) => (
              <div
                key={s.step}
                className={`row ${s.alert ? "alert-row" : ""} ${s.optional ? "optional-row" : ""}`}
                style={{ animationDelay: `${i * 40}ms` }}
              >
                <div className="step-num">{s.step}</div>
                <div>
                  <div className="product-name">{s.product}</div>
                  {s.note && <div className="product-note">{s.note}</div>}
                </div>
                {s.alert && <span className="badge badge-alert">Dokúpiť</span>}
                {s.optional && <span className="badge badge-optional">Voliteľné</span>}
              </div>
            ))}
          </div>

          {tab === "morning" && (
            <div className="note-box" style={{ marginTop: 28 }}>
              <p>
                <strong>Bez SPF stráca všetka starostlivosť zmysel.</strong> Máš pigmentáciu
                aj Niveu Luminous 630 na oko – slnko by zničilo všetku prácu. Odporúčam napr.{" "}
                <em>Beauty of Joseon Relief Sun</em> alebo <em>La Roche-Posay Anthelios</em>.
              </p>
            </div>
          )}

          {tab === "evening" && (
            <div className="note-box" style={{ marginTop: 28 }}>
              <p>
                <strong>Cicaplast B5+</strong> dávaj len keď je pleť unavená, podráždená alebo
                po botoxe. Môžeš ho použiť aj ako{" "}
                <em>sleeping mask</em> – nechaj ho ako posledný krok.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

